import { produce } from "immer";
import * as Actions from "pages/Folders/store/foldersActions";

const initialState = {
  currentFolder: null,
  isFolderAddOpen: false,
  isFolderRenameOpen: false,
  isFolderMoveOpen: false,
  isFolderClearOpen: false,
  isFolderDeleteOpen: false,
  isFolderMarkAllReadOpen: false,
  isLoading: false,
  errorMessage: null,
  isFolderPropertiesOpen: false,
  isFolderShareOpen: false
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.OPEN_FOLDER_ADD:
      const { parentFolder } = action.payload;
      draft.currentFolder = parentFolder;
      draft.isFolderAddOpen = true;
      draft.errorMessage = null;
      break;

    case Actions.CLOSE_FOLDER_ADD:
      draft.isFolderAddOpen = false;
      break;

    case Actions.OPEN_FOLDER_RENAME:
      draft.currentFolder = action.payload.folder;
      draft.isFolderRenameOpen = true;
      draft.errorMessage = null;
      break;

    case Actions.CLOSE_FOLDER_RENAME:
      draft.isFolderRenameOpen = false;
      break;

    case Actions.OPEN_FOLDER_MOVE:
      draft.currentFolder = action.payload.folder;
      draft.isFolderMoveOpen = true;
      draft.errorMessage = null;
      break;

    case Actions.CLOSE_FOLDER_MOVE:
      draft.isFolderMoveOpen = false;
      break;

    case Actions.OPEN_FOLDER_CLEAR:
      draft.currentFolder = action.payload.folder;
      draft.isFolderClearOpen = true;
      draft.errorMessage = null;
      break;

    case Actions.CLOSE_FOLDER_CLEAR:
      draft.isFolderClearOpen = false;
      break;

    case Actions.OPEN_FOLDER_MARK_ALL_READ:
      draft.currentFolder = action.payload.folder;
      draft.isFolderMarkAllReadOpen = true;
      draft.errorMessage = null;
      break;

    case Actions.CLOSE_FOLDER_MARK_ALL_READ:
      draft.isFolderMarkAllReadOpen = false;
      break;

    case Actions.OPEN_FOLDER_DELETE:
      draft.currentFolder = action.payload.folder;
      draft.isFolderDeleteOpen = true;
      draft.errorMessage = null;
      break;

    case Actions.CLOSE_FOLDER_DELETE:
      draft.isFolderDeleteOpen = false;
      break;

    case Actions.ADD_FOLDER:
      draft.isLoading = true;
      break;

    case Actions.ADD_FOLDER_SUCCESS:
      draft.isLoading = false;
      draft.isFolderAddOpen = false;
      break;

    case Actions.ADD_FOLDER_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.RENAME_FOLDER:
      draft.isLoading = true;
      break;

    case Actions.RENAME_FOLDER_SUCCESS:
      draft.isLoading = false;
      draft.isFolderRenameOpen = false;
      break;

    case Actions.RENAME_FOLDER_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.FOLDER_LIFETIME_FAIL:
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.MOVE_FOLDER:
      draft.isLoading = true;
      break;

    case Actions.MOVE_FOLDER_SUCCESS:
      draft.isLoading = false;
      draft.isFolderMoveOpen = false;
      break;

    case Actions.MOVE_FOLDER_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.CLEAR_FOLDER:
      draft.isLoading = true;
      break;

    case Actions.CLEAR_FOLDER_SUCCESS:
      draft.isLoading = false;
      draft.isFolderClearOpen = false;
      break;

    case Actions.CLEAR_FOLDER_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.MARK_ALL_READ_FOLDER:
      draft.isLoading = true;
      break;

    case Actions.MARK_ALL_READ_FOLDER_SUCCESS:
      draft.isLoading = false;
      draft.isFolderMarkAllReadOpen = false;
      break;

    case Actions.MARK_ALL_READ_FOLDER_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.DELETE_FOLDER:
      draft.isLoading = true;
      break;

    case Actions.DELETE_FOLDER_SUCCESS:
      draft.isLoading = false;
      draft.isFolderDeleteOpen = false;
      break;

    case Actions.DELETE_FOLDER_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.OPEN_FOLDER_PROPERTIES:
      draft.currentFolder = action.payload.folder;
      draft.isFolderPropertiesOpen = true;
      draft.errorMessage = null;
      break;

    case Actions.CLOSE_FOLDER_PROPERTIES:
      draft.isLoading = false;
      draft.isFolderPropertiesOpen = false;
      break;

    case Actions.OPEN_FOLDER_SHARE:
      draft.currentFolder = action.payload.folder;
      draft.isFolderShareOpen = true;
      break;

    case Actions.CLOSE_FOLDER_SHARE:
      draft.isFolderShareOpen = false;
      break;

    case Actions.ADD_LIFE_TIME_ERROR:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.CHANGE_FOLDER_COLOR:
      draft.isLoading = true;
      draft.errorMessage = null;
      break;

    case Actions.CHANGE_FOLDER_COLOR_SUCCESS:
      draft.isLoading = false;
      break;

    case Actions.CHANGE_FOLDER_COLOR_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.SET_FAILED:
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.RESET_FAILED:
      draft.errorMessage = null;
      break;

    default:
      break;
  }
}, initialState);

export default reducer;
